(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Ensure polyfill applies even if browser exposes partial native support
// window.__forceSmoothScrollPolyfill__ = true;
// Polyfills & vendor libraries
var $5fdb0a20b06ec8d0$exports = {};
/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */ (function() {
    'use strict';
    // polyfill
    function polyfill() {
        // aliases
        var w = window;
        var d = document;
        // return if scroll behavior is supported and polyfill is not forced
        if ('scrollBehavior' in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) return;
        // globals
        var Element = w.HTMLElement || w.Element;
        var SCROLL_TIME = 468;
        // object gathering original scroll methods
        var original = {
            scroll: w.scroll || w.scrollTo,
            scrollBy: w.scrollBy,
            elementScroll: Element.prototype.scroll || scrollElement,
            scrollIntoView: Element.prototype.scrollIntoView
        };
        // define timing method
        var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
        /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */ function isMicrosoftBrowser(userAgent) {
            var userAgentPatterns = [
                'MSIE ',
                'Trident/',
                'Edge/'
            ];
            return new RegExp(userAgentPatterns.join('|')).test(userAgent);
        }
        /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */ var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
        /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function scrollElement(x, y) {
            this.scrollLeft = x;
            this.scrollTop = y;
        }
        /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */ function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        }
        /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */ function shouldBailOut(firstArg) {
            if (firstArg === null || typeof firstArg !== 'object' || firstArg.behavior === undefined || firstArg.behavior === 'auto' || firstArg.behavior === 'instant') // first argument is not an object/null
            // or behavior is auto, instant or undefined
            return true;
            if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') // first argument is an object and behavior is smooth
            return false;
            // throw error when behavior is not supported
            throw new TypeError('behavior member of ScrollOptions ' + firstArg.behavior + ' is not a valid value for enumeration ScrollBehavior.');
        }
        /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function hasScrollableSpace(el, axis) {
            if (axis === 'Y') return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
            if (axis === 'X') return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
        }
        /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function canOverflow(el, axis) {
            var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];
            return overflowValue === 'auto' || overflowValue === 'scroll';
        }
        /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function isScrollable(el) {
            var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
            var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');
            return isScrollableY || isScrollableX;
        }
        /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */ function findScrollableParent(el) {
            while(el !== d.body && isScrollable(el) === false)el = el.parentNode || el.host;
            return el;
        }
        /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */ function step(context) {
            var time = now();
            var value;
            var currentX;
            var currentY;
            var elapsed = (time - context.startTime) / SCROLL_TIME;
            // avoid elapsed times higher than one
            elapsed = elapsed > 1 ? 1 : elapsed;
            // apply easing to elapsed time
            value = ease(elapsed);
            currentX = context.startX + (context.x - context.startX) * value;
            currentY = context.startY + (context.y - context.startY) * value;
            context.method.call(context.scrollable, currentX, currentY);
            // scroll more if we have not reached our destination
            if (currentX !== context.x || currentY !== context.y) w.requestAnimationFrame(step.bind(w, context));
        }
        /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function smoothScroll(el, x, y) {
            var scrollable;
            var startX;
            var startY;
            var method;
            var startTime = now();
            // define scroll context
            if (el === d.body) {
                scrollable = w;
                startX = w.scrollX || w.pageXOffset;
                startY = w.scrollY || w.pageYOffset;
                method = original.scroll;
            } else {
                scrollable = el;
                startX = el.scrollLeft;
                startY = el.scrollTop;
                method = scrollElement;
            }
            // scroll looping over a frame
            step({
                scrollable: scrollable,
                method: method,
                startTime: startTime,
                startX: startX,
                startY: startY,
                x: x,
                y: y
            });
        }
        // ORIGINAL METHODS OVERRIDES
        // w.scroll and w.scrollTo
        w.scroll = w.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== 'object' ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
                arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
        };
        // w.scrollBy
        w.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0])) {
                original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== 'object' ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
        };
        // Element.prototype.scroll and Element.prototype.scrollTo
        Element.prototype.scroll = Element.prototype.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                // if one number is passed, throw error to match Firefox implementation
                if (typeof arguments[0] === 'number' && arguments[1] === undefined) throw new SyntaxError('Value could not be converted');
                original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
                arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
                arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);
                return;
            }
            var left = arguments[0].left;
            var top = arguments[0].top;
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(this, this, typeof left === 'undefined' ? this.scrollLeft : ~~left, typeof top === 'undefined' ? this.scrollTop : ~~top);
        };
        // Element.prototype.scrollBy
        Element.prototype.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                return;
            }
            this.scroll({
                left: ~~arguments[0].left + this.scrollLeft,
                top: ~~arguments[0].top + this.scrollTop,
                behavior: arguments[0].behavior
            });
        };
        // Element.prototype.scrollIntoView
        Element.prototype.scrollIntoView = function() {
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            var scrollableParent = findScrollableParent(this);
            var parentRects = scrollableParent.getBoundingClientRect();
            var clientRects = this.getBoundingClientRect();
            if (scrollableParent !== d.body) {
                // reveal element inside parent
                smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);
                // reveal parent in viewport unless is fixed
                if (w.getComputedStyle(scrollableParent).position !== 'fixed') w.scrollBy({
                    left: parentRects.left,
                    top: parentRects.top,
                    behavior: 'smooth'
                });
            } else // reveal element in viewport
            w.scrollBy({
                left: clientRects.left,
                top: clientRects.top,
                behavior: 'smooth'
            });
        };
    }
    // commonjs
    $5fdb0a20b06ec8d0$exports = {
        polyfill: polyfill
    };
})();


console.log(`Loading default.js`);
// Fixed navigation bar functionality using Intersection Observer
// SMOOTH SCROLL — resilient to layout shifts from lazy-loaded images
let $cc3044682511acf2$var$scrollGeneration = 0;
document.addEventListener("click", (event)=>{
    const anchor = event.target.closest("a[href]");
    if (!anchor) return;
    const rawHref = anchor.getAttribute("href");
    const isHashOnly = rawHref.startsWith("#");
    const url = new URL(rawHref, window.location.href);
    const normalize = (p)=>(p || "/").replace(/\/index\.php$/i, "").replace(/\/+$/, "");
    const sameOrigin = url.origin === window.location.origin;
    const sameDoc = isHashOnly || normalize(url.pathname) === normalize(window.location.pathname);
    if (url.hash && sameOrigin && sameDoc) {
        const target = document.querySelector(url.hash);
        if (!target) return;
        event.preventDefault();
        history.pushState(null, "", url.hash);
        $cc3044682511acf2$var$scrollWithLayoutCorrection(target);
    }
});
function $cc3044682511acf2$var$scrollWithLayoutCorrection(target) {
    const gen = ++$cc3044682511acf2$var$scrollGeneration;
    let cancelled = false;
    const cancelOnUserScroll = ()=>{
        cancelled = true;
        cleanup();
    };
    const userEvents = [
        "wheel",
        "touchstart",
        "keydown"
    ];
    userEvents.forEach((e)=>window.addEventListener(e, cancelOnUserScroll, {
            once: true,
            passive: true
        }));
    const cleanup = ()=>{
        userEvents.forEach((e)=>window.removeEventListener(e, cancelOnUserScroll));
    };
    const isStale = ()=>cancelled || gen !== $cc3044682511acf2$var$scrollGeneration;
    target.scrollIntoView({
        behavior: "smooth"
    });
    const pending = [
        ...document.images
    ].filter((img)=>!img.complete);
    if (!pending.length) {
        cleanup();
        return;
    }
    let timer;
    const scheduleCorrection = ()=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            if (isStale()) return;
            target.scrollIntoView({
                behavior: "smooth"
            });
        }, 120);
    };
    for (const img of pending){
        img.addEventListener("load", scheduleCorrection, {
            once: true
        });
        img.addEventListener("error", scheduleCorrection, {
            once: true
        });
    }
    setTimeout(()=>{
        if (isStale()) return;
        target.scrollIntoView({
            behavior: "smooth"
        });
        cleanup();
    }, 3000);
}
// DREAMFORM ADAPTION
// DREAMFORM ADAPTION
// DREAMFORM ADAPTION
// hide required * elms and others
document.querySelectorAll('em[aria-hidden="true"]').forEach((el)=>{
    el.style.display = "none";
});
document.querySelectorAll("label").forEach((el)=>{
    el.style.display = "none";
});
document.querySelectorAll("textarea").forEach((el)=>el.rows = 4);
// ACCORDION
// ACCORDION
// ACCORDION
document.querySelectorAll(".accordion-container").forEach((container)=>{
    const head = container.querySelector(".acc-head");
    const body = container.querySelector(".acc-body");
    const inner = body.querySelector(".acc-inner");
    const arrow = head.querySelector("svg");
    let isOpen = false;
    const getFullHeight = ()=>{
        const style = window.getComputedStyle(inner);
        const marginTop = parseFloat(style.marginTop) || 0;
        const marginBottom = parseFloat(style.marginBottom) || 0;
        return inner.scrollHeight + marginTop + marginBottom;
    };
    head.addEventListener("click", ()=>{
        isOpen = !isOpen;
        arrow.classList.toggle("!rotate-360", isOpen);
        if (isOpen) // Expand: set height to content's full height including margins
        body.style.height = getFullHeight() + "px";
        else // Collapse: set height to 0
        body.style.height = "0px";
    });
    // Update height on window resize (in case content reflows)
    window.addEventListener("resize", ()=>{
        if (isOpen) body.style.height = getFullHeight() + "px";
    });
});
// ACTIVE NAV BAR
// ACTIVE NAV BAR
// ACTIVE NAV BAR
(()=>{
    // The section IDs we care about
    const SECTION_IDS = [
        "shop",
        "wer",
        "wann",
        "b2b",
        "wo"
    ];
    // Collect existing sections/footer by ID (ignore missing)
    const sections = SECTION_IDS.map((id)=>document.getElementById(id)).filter(Boolean);
    if (!sections.length) return;
    // on other page then home return
    if (sections.length !== SECTION_IDS.length) return;
    // Map sectionId -> [all matching anchors anywhere on the page]
    const anchorsById = SECTION_IDS.reduce((acc, id)=>{
        const anchors = Array.from(document.querySelectorAll('a[href*="#"]')).filter((a)=>{
            try {
                const u = new URL(a.href, location.href);
                return u.hash.replace(/^#/, "") === id;
            } catch  {
                return a.hash && a.hash.replace(/^#/, "") === id;
            }
        });
        if (anchors.length) acc[id] = anchors;
        return acc;
    }, {});
    // Helper to set the active class on all matching anchors
    let currentActive = null;
    const setActive = (id)=>{
        if (id === currentActive) return;
        // Clear all first
        Object.values(anchorsById).forEach((list)=>list.forEach((a)=>a.classList.remove("is-active")));
        // Set new
        if (id && anchorsById[id]) anchorsById[id].forEach((a)=>a.classList.add("is-active"));
        currentActive = id;
    };
    // Track visible pixel height per section (immune to tall-section bias)
    const visiblePx = new Map(SECTION_IDS.map((id)=>[
            id,
            0
        ]));
    const pickMostVisible = ()=>{
        // "wo" is the footer — if it's visible at all, it always wins
        if (visiblePx.get("wo") > 0) {
            setActive("wo");
            return;
        }
        let bestId = null;
        let bestPx = 0;
        visiblePx.forEach((px, id)=>{
            if (px > bestPx) {
                bestPx = px;
                bestId = id;
            }
        });
        const minPx = window.innerHeight * 0.15;
        setActive(bestPx >= minPx ? bestId : null);
    };
    const io = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const id = entry.target.id;
            if (!entry.isIntersecting) {
                visiblePx.set(id, 0);
                return;
            }
            const rect = entry.boundingClientRect;
            const vpH = entry.rootBounds?.height ?? window.innerHeight;
            const top = Math.max(rect.top, 0);
            const bottom = Math.min(rect.bottom, vpH);
            visiblePx.set(id, Math.max(0, bottom - top));
        });
        pickMostVisible();
    }, {
        root: null,
        rootMargin: "0% 0px 0% 0px",
        threshold: [
            0,
            0.05,
            0.1,
            0.25,
            0.5,
            0.75,
            1
        ]
    });
    sections.forEach((sec)=>{
        io.observe(sec);
    });
    // Keep active state correct on hash navigation (e.g., user clicks a nav link)
    window.addEventListener("hashchange", ()=>{
        const id = location.hash.replace(/^#/, "");
        if (SECTION_IDS.includes(id)) setActive(id);
    });
    // On page load, if we landed on a hash, set it immediately
    const initialId = location.hash.replace(/^#/, "");
    if (SECTION_IDS.includes(initialId)) setActive(initialId);
})();
// NAV BAR SET MARGIN FOR STICKY POSITION
// NAV BAR HIDDEN ON SCROLL TO TOP
// NAV BAR HIDDEN ON SCROLL TO TOP
const $cc3044682511acf2$var$navBar = document.querySelector(".nav-bar");
const $cc3044682511acf2$var$splash = document.querySelector(".section-splashscreen");
const $cc3044682511acf2$var$root = getComputedStyle(document.documentElement);
// Read Tailwind theme var each time (fallback to 900 if missing)
const $cc3044682511acf2$var$getBreakpoint = ()=>{
    const raw = $cc3044682511acf2$var$root.getPropertyValue("--breakpoint-mdplus").trim(); // e.g. "900" or "900px"
    const n = parseInt(raw, 10);
    return Number.isFinite(n) ? n : 900;
};
// --- layout: position nav for small screens ---
const $cc3044682511acf2$var$positionNavBar = ()=>{
    const w = window.innerWidth;
    const BP_MDPLUS = $cc3044682511acf2$var$getBreakpoint();
    if (w < BP_MDPLUS) {
        const h = window.innerHeight;
        const rect = $cc3044682511acf2$var$navBar.getBoundingClientRect();
        const navBarHeightNoMargins = rect.height;
        const topValue = (h - navBarHeightNoMargins) / 2;
        $cc3044682511acf2$var$navBar.style.marginTop = `${topValue}px`;
        $cc3044682511acf2$var$splash.style.marginTop = `${-topValue - navBarHeightNoMargins}px`;
    }
};
// Single scroll handler registered once (checks viewport each scroll)
const $cc3044682511acf2$var$setupScrollBehavior = ()=>{
    const navImgEl = document.querySelector(".nav-bar img");
    const navBarHideElm = document.querySelector(".nav-bar-hide-elm");
    let isScrolled = false;
    window.addEventListener("scroll", ()=>{
        const scrolled = window.scrollY > 0;
        if (scrolled === isScrolled) return;
        isScrolled = scrolled;
        const isMobile = window.innerWidth < $cc3044682511acf2$var$getBreakpoint();
        if (isMobile) {
            if (navImgEl) navImgEl.classList.toggle("!w-82", scrolled);
        } else if (navBarHideElm) navBarHideElm.style.zIndex = scrolled ? "4" : "7";
    }, {
        passive: true
    });
};
if ($cc3044682511acf2$var$splash) {
    // ON HOME PAGE
    const runPositionAndSignal = ()=>{
        $cc3044682511acf2$var$positionNavBar();
        window.__navPositionReady = true;
        window.dispatchEvent(new CustomEvent("nav-position-ready"));
    };
    const navImg = $cc3044682511acf2$var$navBar.querySelector("img");
    if (navImg && !navImg.complete) {
        navImg.addEventListener("load", runPositionAndSignal, {
            once: true
        });
        navImg.addEventListener("error", runPositionAndSignal, {
            once: true
        });
    } else runPositionAndSignal();
    $cc3044682511acf2$var$setupScrollBehavior();
    let lastWidth = window.innerWidth;
    window.addEventListener("resize", ()=>{
        const newWidth = window.innerWidth;
        if (newWidth !== lastWidth) {
            $cc3044682511acf2$var$positionNavBar();
            lastWidth = newWidth;
        }
        if (newWidth > $cc3044682511acf2$var$BP_MDPLUS) {
            $cc3044682511acf2$var$splash.style.marginTop = "0";
            $cc3044682511acf2$var$navBar.style.marginTop = "0";
        }
    });
} else {
    // ON OTHER PAGES FIXED NAV BAR
    $cc3044682511acf2$var$setupScrollBehavior();
    const navBarHideElm = document.querySelector(".nav-bar-hide-elm");
    navBarHideElm.style.zIndex = "4";
}
// SHOW PRODUCTS INGREDIENTS ON TOUCH
// SHOW PRODUCTS INGREDIENTS ON TOUCH
// SHOW PRODUCTS INGREDIENTS ON TOUCH
const $cc3044682511acf2$var$hideOnTouchEls = document.querySelectorAll(".hide-on-touch");
function $cc3044682511acf2$var$resetAllHideOnTouch() {
    $cc3044682511acf2$var$hideOnTouchEls.forEach((el)=>el.style.opacity = "1");
}
function $cc3044682511acf2$var$handleHideOnTouch(e) {
    $cc3044682511acf2$var$resetAllHideOnTouch();
    e.currentTarget.style.opacity = "0";
}
$cc3044682511acf2$var$hideOnTouchEls.forEach((el)=>el.addEventListener("touchstart", $cc3044682511acf2$var$handleHideOnTouch));
// ON MOBILE SWITCH FORM FIELD NACHRICHT TO BE LAST
// ON MOBILE SWITCH FORM FIELD NACHRICHT TO BE LAST
// ON MOBILE SWITCH FORM FIELD NACHRICHT TO BE LAST
const $cc3044682511acf2$var$BP_MDPLUS = $cc3044682511acf2$var$getBreakpoint();
const $cc3044682511acf2$var$form = document.querySelector("[data-b2b-form] form");
const $cc3044682511acf2$var$nachrichtGroup = $cc3044682511acf2$var$form?.querySelector('textarea[name="nachricht"]')?.closest(".group");
const $cc3044682511acf2$var$originalNachrichtParent = $cc3044682511acf2$var$nachrichtGroup?.parentElement || null;
if ($cc3044682511acf2$var$form) {
    const isCartPath = /\/cart\/?$/.test(window.location.pathname);
    const basePath = window.location.pathname.replace(/\/cart\/?$/, "/");
    const baseUrl = window.location.origin + basePath;
    const action = $cc3044682511acf2$var$form.getAttribute("action") || "";
    if (isCartPath && (action === "" || action === "/cart" || action === "/cart/" || action.includes("/cart"))) $cc3044682511acf2$var$form.setAttribute("action", `${baseUrl}#b2b`);
}
const $cc3044682511acf2$var$getRowColumns = (row)=>Array.from(row.children).filter((el)=>el.tagName === "DIV");
function $cc3044682511acf2$var$moveNachrichtField() {
    const w = window.innerWidth;
    if (!$cc3044682511acf2$var$form || !$cc3044682511acf2$var$nachrichtGroup || !$cc3044682511acf2$var$originalNachrichtParent) return;
    const grids = Array.from($cc3044682511acf2$var$form.querySelectorAll(".gap-4.mb-4"));
    if (!grids.length) return;
    const submitRow = grids.find((row)=>row.querySelector('button[type="submit"]'));
    if (!submitRow) return;
    const [leftCol, rightCol] = $cc3044682511acf2$var$getRowColumns(submitRow);
    if (!leftCol || !rightCol) return;
    const submitBtnGroup = Array.from(rightCol.children).find((el)=>el.querySelector('button[type="submit"]'));
    // small screen: move into right column before submit
    if (w < $cc3044682511acf2$var$BP_MDPLUS && rightCol !== $cc3044682511acf2$var$nachrichtGroup.parentElement) {
        if (submitBtnGroup) rightCol.insertBefore($cc3044682511acf2$var$nachrichtGroup, submitBtnGroup);
        else rightCol.appendChild($cc3044682511acf2$var$nachrichtGroup);
        $cc3044682511acf2$var$nachrichtGroup.querySelector("textarea").style.borderTop = "none";
    }
    // large screen: move back into its original column (if needed)
    if (w >= $cc3044682511acf2$var$BP_MDPLUS && $cc3044682511acf2$var$nachrichtGroup.parentElement !== $cc3044682511acf2$var$originalNachrichtParent) {
        $cc3044682511acf2$var$originalNachrichtParent.appendChild($cc3044682511acf2$var$nachrichtGroup);
        $cc3044682511acf2$var$nachrichtGroup.querySelector("textarea").style.borderTop = "";
    }
}
// initial run
$cc3044682511acf2$var$moveNachrichtField();
// STYLE FORM ERROR MESSAGES
// STYLE FORM ERROR MESSAGES
// STYLE FORM ERROR MESSAGES
const $cc3044682511acf2$var$submittedFlagKey = "b2b-form-submitted";
const $cc3044682511acf2$var$markFormSubmitted = ()=>{
    $cc3044682511acf2$var$form?.classList.add("is-submitted");
    sessionStorage.setItem($cc3044682511acf2$var$submittedFlagKey, "1");
};
if ($cc3044682511acf2$var$form && sessionStorage.getItem($cc3044682511acf2$var$submittedFlagKey) === "1" && $cc3044682511acf2$var$form.querySelector("[data-has-error]")) $cc3044682511acf2$var$form.classList.add("is-submitted");
else sessionStorage.removeItem($cc3044682511acf2$var$submittedFlagKey);
$cc3044682511acf2$var$form?.addEventListener("submit", $cc3044682511acf2$var$markFormSubmitted);
// CART CHECKOUT FORM VALIDATION (no native tooltip)
// CART CHECKOUT FORM VALIDATION (no native tooltip)
// CART CHECKOUT FORM VALIDATION (no native tooltip)
document.addEventListener("submit", (event)=>{
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches("[data-checkout-form]")) return;
    if (form.checkValidity()) return;
    event.preventDefault();
    form.dataset.submitted = "true";
}, true);
// FIX POS OF "&" IN HERO
// FIX POS OF "&" IN HERO
// FIX POS OF "&" IN HERO
// run on resize with debounce
let $cc3044682511acf2$var$resizeTimeout;
window.addEventListener("resize", ()=>{
    clearTimeout($cc3044682511acf2$var$resizeTimeout);
    $cc3044682511acf2$var$resizeTimeout = setTimeout($cc3044682511acf2$var$moveNachrichtField, 150);
});
const $cc3044682511acf2$var$updateH1FontSize = ()=>{
    let offset = 28;
    if (window.innerWidth > 1024) offset = 32;
    if (window.innerWidth > 1280) offset = 64;
    // console.log(`offset: ${offset}`);
    const factor = window.innerWidth < 900 ? 27.5 : window.innerWidth > 1280 ? 56.5 : 57.5;
    const size = (window.innerWidth - offset) / factor;
    document.querySelectorAll(".section-splashscreen *, footer *").forEach((elm)=>{
        elm.style.fontSize = `${size}px`;
    // console.log(`h1 font size: ${size}px`);
    });
};
$cc3044682511acf2$var$updateH1FontSize();
window.addEventListener("resize", $cc3044682511acf2$var$updateH1FontSize);
// STYLE FOCUS COLOR
// STYLE FOCUS COLOR
// STYLE FOCUS COLOR
window.addEventListener("keydown", function(e) {
    // Check if the Tab key (keyCode 9) was pressed
    if (e.key === "Tab" || e.keyCode === 9) {
        document.body.classList.add("is-keyboard-user");
        document.body.classList.remove("is-mouse-user");
    }
});
window.addEventListener("mousedown", function() {
    document.body.classList.add("is-mouse-user");
    document.body.classList.remove("is-keyboard-user");
});


//  SPLASH IMAGE FADE
//  SPLASH IMAGE FADE
//  SPLASH IMAGE FADE
const $d5194bb3e3143261$var$normals = Array.from(document.querySelectorAll(".splash-normal"));
const $d5194bb3e3143261$var$lightens = Array.from(document.querySelectorAll(".splash-lighten"));
const $d5194bb3e3143261$var$splashCover = document.querySelector("[data-splash-cover]");
const $d5194bb3e3143261$var$splashLogo = document.querySelector("[data-splash-logo]");
let $d5194bb3e3143261$var$coverFailSafeTimer = null;
const $d5194bb3e3143261$var$hideSplashCover = ()=>{
    if (!$d5194bb3e3143261$var$splashCover) return;
    if ($d5194bb3e3143261$var$splashCover.dataset.hidden === "true") return;
    if ($d5194bb3e3143261$var$coverFailSafeTimer) {
        clearTimeout($d5194bb3e3143261$var$coverFailSafeTimer);
        $d5194bb3e3143261$var$coverFailSafeTimer = null;
    }
    $d5194bb3e3143261$var$splashCover.dataset.hidden = "true";
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            $d5194bb3e3143261$var$splashCover.style.transition = "opacity 220ms ease-out";
            $d5194bb3e3143261$var$splashCover.style.opacity = "0";
            const removeCover = ()=>{
                if ($d5194bb3e3143261$var$splashCover.isConnected) $d5194bb3e3143261$var$splashCover.remove();
            };
            $d5194bb3e3143261$var$splashCover.addEventListener("transitionend", removeCover, {
                once: true
            });
            setTimeout(removeCover, 320);
        });
    });
};
if ($d5194bb3e3143261$var$normals.length > 0 && $d5194bb3e3143261$var$lightens.length > 0) {
    if ($d5194bb3e3143261$var$splashCover) // Hard safety so cover can never block indefinitely.
    $d5194bb3e3143261$var$coverFailSafeTimer = setTimeout(()=>{
        $d5194bb3e3143261$var$hideSplashCover();
    }, 7000);
    const total = Math.min($d5194bb3e3143261$var$normals.length, $d5194bb3e3143261$var$lightens.length);
    const initialStartDelay = 3800; // delay before switch from img0 to img1 also in second loop
    const imageNextImageDelay = 5500; // switch to next image; longer creates a pause where image is full visible
    const fadeDurationNormal = 300; // duration of the fade transition from normal to lighten, bit more than the fadeDuration for connected feel
    const fadeDuration = 400; // duration of the fade transition from lighten to the next image, roughly half of the imageNextImageDelay
    let deferredMediaActivated = false;
    const setFadeTransitionNormal = (el)=>{
        el.style.transition = `opacity ${fadeDurationNormal}ms ease-out`;
    };
    const setInitialOpacity = (el)=>{
        el.style.opacity = `1`;
    };
    const setFadeTransition = (el)=>{
        el.style.transition = `opacity ${fadeDuration}ms ease-out`;
    };
    const getWrapper = (el)=>el.closest("picture") || el;
    const normalWraps = $d5194bb3e3143261$var$normals.map(getWrapper);
    const lightenWraps = $d5194bb3e3143261$var$lightens.map(getWrapper);
    let firstImageReady = false;
    let logoReady = false;
    let navReady = !!window.__navPositionReady;
    const maybeHideSplashCover = ()=>{
        if (firstImageReady && logoReady && navReady) $d5194bb3e3143261$var$hideSplashCover();
    };
    if (!navReady) window.addEventListener("nav-position-ready", ()=>{
        navReady = true;
        maybeHideSplashCover();
    }, {
        once: true
    });
    const markLogoReady = ()=>{
        logoReady = true;
        maybeHideSplashCover();
    };
    if (!$d5194bb3e3143261$var$splashLogo || getComputedStyle($d5194bb3e3143261$var$splashLogo).display === "none") logoReady = true;
    else if ($d5194bb3e3143261$var$splashLogo.complete && $d5194bb3e3143261$var$splashLogo.naturalHeight !== 0) logoReady = true;
    else {
        $d5194bb3e3143261$var$splashLogo.addEventListener("load", markLogoReady, {
            once: true
        });
        $d5194bb3e3143261$var$splashLogo.addEventListener("error", markLogoReady, {
            once: true
        });
    }
    const activateDeferredMedia = ()=>{
        if (deferredMediaActivated) return;
        deferredMediaActivated = true;
        document.querySelectorAll("picture[data-deferred-media]").forEach((picture)=>{
            picture.querySelectorAll("source[data-srcset]").forEach((source)=>{
                source.setAttribute("srcset", source.dataset.srcset || "");
                source.removeAttribute("data-srcset");
            });
            const img = picture.querySelector("img[data-src]");
            if (img) {
                img.setAttribute("src", img.dataset.src || "");
                img.removeAttribute("data-src");
            }
            picture.removeAttribute("data-deferred-media");
        });
    };
    // Reveal hidden images only after the top image has loaded
    const topImage = $d5194bb3e3143261$var$normals[0];
    const revealHiddenImages = ()=>{
        activateDeferredMedia();
        // Skip the first image (index 0) - it's already visible
        const hiddenImages = [
            ...$d5194bb3e3143261$var$normals.slice(1),
            ...$d5194bb3e3143261$var$lightens.slice(1)
        ];
        const hiddenWraps = [
            ...normalWraps.slice(1),
            ...lightenWraps.slice(1)
        ];
        [
            ...hiddenImages,
            ...hiddenWraps
        ].forEach((el)=>{
            el.style.transition = "none";
            el.style.opacity = "1";
            el.offsetHeight; // force reflow
        });
        // Also ensure first lighten is visible (it shares z-index layer with first normal)
        $d5194bb3e3143261$var$lightens[0].style.transition = "none";
        $d5194bb3e3143261$var$lightens[0].style.opacity = "1";
        lightenWraps[0].style.transition = "none";
        lightenWraps[0].style.opacity = "1";
        // Then apply fade transitions to all images
        setTimeout(()=>{
            $d5194bb3e3143261$var$normals.forEach(setFadeTransitionNormal);
            setInitialOpacity($d5194bb3e3143261$var$normals[0]);
            $d5194bb3e3143261$var$lightens.forEach(setFadeTransition);
            firstImageReady = true;
            maybeHideSplashCover();
        }, 50);
    };
    // Check if already loaded (cached) or wait for load event
    if (topImage.complete && topImage.naturalHeight !== 0) revealHiddenImages();
    else {
        topImage.addEventListener("load", revealHiddenImages, {
            once: true
        });
        topImage.addEventListener("error", ()=>{
            firstImageReady = true;
            maybeHideSplashCover();
        }, {
            once: true
        });
    }
    [
        ...normalWraps,
        ...lightenWraps
    ].forEach((wrap)=>{
        if (!wrap.dataset.origZ) wrap.dataset.origZ = getComputedStyle(wrap).zIndex;
    });
    const resetZIndices = ()=>{
        [
            ...normalWraps,
            ...lightenWraps
        ].forEach((wrap)=>{
            const orig = wrap.dataset.origZ;
            if (orig && orig !== "auto") wrap.style.zIndex = orig;
            else wrap.style.removeProperty("z-index");
        });
    };
    const resetVisibility = ()=>{
        resetZIndices();
        $d5194bb3e3143261$var$normals.forEach((el)=>{
            el.style.transition = "none";
            el.style.opacity = "1";
            el.offsetHeight;
            setFadeTransitionNormal(el);
        });
        $d5194bb3e3143261$var$lightens.forEach((el)=>{
            el.style.transition = "none";
            el.style.opacity = "1";
            el.offsetHeight;
            setFadeTransition(el);
        });
    };
    const revealFirstBelowLast = ()=>{
        const firstNormal = $d5194bb3e3143261$var$normals[0];
        const firstLighten = $d5194bb3e3143261$var$lightens[0];
        const lastNormalWrap = normalWraps[total - 1];
        const firstNormalWrap = normalWraps[0];
        const firstLightenWrap = lightenWraps[0];
        const lastNormalZ = parseInt(getComputedStyle(lastNormalWrap).zIndex, 10);
        const zBase = Number.isFinite(lastNormalZ) ? lastNormalZ : 0;
        firstNormalWrap.style.zIndex = String(zBase - 2);
        firstLightenWrap.style.zIndex = String(zBase - 1);
        firstNormal.style.transition = "none";
        firstNormal.style.opacity = "1";
        firstNormal.offsetHeight;
        setFadeTransitionNormal(firstNormal);
        firstLighten.style.transition = "none";
        firstLighten.style.opacity = "1";
        firstLighten.offsetHeight;
        setFadeTransition(firstLighten);
    };
    const runCycle = ()=>{
        const startDelay = initialStartDelay;
        for(let i = 0; i < total; i++){
            const normal = $d5194bb3e3143261$var$normals[i];
            const lighten = $d5194bb3e3143261$var$lightens[i];
            const baseDelay = i * imageNextImageDelay;
            const isLast = i === total - 1;
            setTimeout(()=>{
                normal.style.opacity = "0";
            }, baseDelay + startDelay);
            if (isLast) {
                const revealLead = 100;
                const revealDelay = Math.max(0, baseDelay + startDelay - revealLead);
                setTimeout(()=>{
                    revealFirstBelowLast();
                }, revealDelay);
            }
            setTimeout(()=>{
                lighten.style.opacity = "0";
            }, baseDelay + startDelay + fadeDuration);
        }
        const resetDelay = ($d5194bb3e3143261$var$normals.length - 1) * imageNextImageDelay + startDelay + fadeDuration + fadeDuration;
        // console.log(`resetDelay: ${resetDelay}`);
        setTimeout(()=>{
            resetVisibility();
            runCycle();
        }, resetDelay);
    };
    runCycle();
} else // No splash images: don't block the page if cover exists.
$d5194bb3e3143261$var$hideSplashCover();


const $6be3643148e663ef$export$69c3c142561da2b0 = (root = document)=>{
    const galleries = root.querySelectorAll("[data-product-gallery]");
    galleries.forEach((gallery)=>{
        if (gallery.dataset.galleryBound === "true") return;
        const images = Array.from(gallery.querySelectorAll("[data-gallery-image]"));
        if (images.length <= 1) return;
        const setActive = (nextIndex)=>{
            images.forEach((img, index)=>{
                img.classList.toggle("opacity-100", index === nextIndex);
                img.classList.toggle("opacity-0", index !== nextIndex);
            });
            gallery.dataset.galleryIndex = String(nextIndex);
        };
        gallery.dataset.galleryIndex = "0";
        gallery.dataset.galleryBound = "true";
        gallery.addEventListener("click", ()=>{
            const currentIndex = parseInt(gallery.dataset.galleryIndex || "0", 10);
            const nextIndex = (currentIndex + 1) % images.length;
            setActive(nextIndex);
        });
    });
};
$6be3643148e663ef$export$69c3c142561da2b0();


const $c1a961f7c5111ced$export$350d9cc3c8c2e2a9 = (root = document)=>{
    const optionGroups = root.querySelectorAll("[data-qty-options]");
    optionGroups.forEach((group)=>{
        if (group.dataset.qtyBound === "true") return;
        const container = group.closest("form") || group.parentElement;
        const input = container?.querySelector("[data-qty-input]");
        const display = container?.querySelector("[data-qty-display]");
        const displayTrigger = container?.querySelector("[data-qty-display-trigger]");
        const displayArrow = container?.querySelector("[data-qty-arrow]");
        const priceBox = container?.querySelector("[data-price-calculation-display]");
        const priceTotal = container?.querySelector("[data-price-total]");
        const buttons = Array.from(group.querySelectorAll("[data-qty-value]"));
        const customInput = group.querySelector("[data-qty-custom]");
        if (!input || !display || !displayTrigger) return;
        const updatePriceTotal = (value)=>{
            if (!priceBox || !priceTotal) return;
            const unit = parseFloat(priceBox.dataset.priceValue || "0");
            const qty = parseFloat(String(value)) || 0;
            const total = unit * qty;
            priceTotal.textContent = total.toFixed(2);
        };
        const setActive = (value)=>{
            input.value = String(value);
            display.textContent = String(value);
            updatePriceTotal(value);
            buttons.forEach((btn)=>{
                btn.classList.toggle(btn.dataset.qtyValue === value);
            });
        };
        setActive(input.value || "1");
        group.dataset.qtyBound = "true";
        const closeAllOptionGroups = ()=>{
            const allGroups = container?.querySelectorAll("[data-qty-options], [data-abo-options], [data-pickup-options]");
            allGroups?.forEach((g)=>{
                g.classList.remove("flex", "flex-col", "h-auto");
                g.classList.add("h-0");
            });
            container?.querySelectorAll("[data-qty-arrow], [data-abo-arrow], [data-pickup-arrow]").forEach((arrow)=>arrow.classList.remove("hidden"));
            container?.querySelectorAll("[data-qty-display-trigger], [data-abo-display-trigger], [data-pickup-display-trigger]").forEach((trigger)=>trigger.classList.remove("hover:border-b"));
        };
        displayTrigger.addEventListener("click", ()=>{
            const isClosed = group.classList.contains("h-0");
            closeAllOptionGroups();
            if (isClosed) {
                group.classList.remove("h-0");
                group.classList.add("flex", "flex-col", "h-auto");
                displayArrow?.classList.add("hidden");
                displayTrigger.classList.add("hover:border-b");
            }
        });
        buttons.forEach((btn)=>{
            btn.addEventListener("click", ()=>{
                const value = btn.dataset.qtyValue || "1";
                setActive(value);
            //closeAllOptionGroups();
            });
        });
        if (customInput) {
            const updateCustom = ()=>{
                const raw = parseInt(customInput.value, 10);
                if (!Number.isFinite(raw) || raw <= 0) return;
                setActive(String(raw));
            //closeAllOptionGroups();
            };
            customInput.addEventListener("input", updateCustom);
            customInput.addEventListener("change", updateCustom);
        }
    });
};
const $c1a961f7c5111ced$export$c77a4f745cd1d4d9 = ()=>{};
const $c1a961f7c5111ced$export$d860d8ed399a1993 = (root = document)=>{
    const optionGroups = root.querySelectorAll("[data-pickup-options]");
    optionGroups.forEach((group)=>{
        if (group.dataset.pickupBound === "true") return;
        const container = group.closest("form") || group.parentElement;
        const input = container?.querySelector("[data-pickup-input]");
        const display = container?.querySelector("[data-pickup-display]");
        const displayTrigger = container?.querySelector("[data-pickup-display-trigger]");
        const displayArrow = container?.querySelector("[data-pickup-arrow]");
        const buttons = Array.from(group.querySelectorAll("[data-pickup-value]"));
        if (!input || !display || !displayTrigger || buttons.length === 0) return;
        const setActive = (value, label)=>{
            input.value = String(value);
            display.textContent = label || String(value);
            buttons.forEach((btn)=>{
                btn.classList.toggle(btn.dataset.pickupValue === value);
            });
        };
        // Get initial label from first button or display
        const firstBtn = buttons[0];
        const initialValue = input.value || firstBtn?.dataset.pickupValue || "";
        const initialLabel = display.textContent || firstBtn?.dataset.pickupLabel || initialValue;
        setActive(initialValue, initialLabel);
        group.dataset.pickupBound = "true";
        const closeAllOptionGroups = ()=>{
            const allGroups = container?.querySelectorAll("[data-qty-options], [data-abo-options], [data-pickup-options]");
            allGroups?.forEach((g)=>{
                g.classList.remove("flex", "flex-col", "h-auto");
                g.classList.add("h-0");
            });
            container?.querySelectorAll("[data-qty-arrow], [data-abo-arrow], [data-pickup-arrow]").forEach((arrow)=>arrow.classList.remove("hidden"));
            container?.querySelectorAll("[data-qty-display-trigger], [data-abo-display-trigger], [data-pickup-display-trigger]").forEach((trigger)=>trigger.classList.remove("hover:border-b"));
        };
        displayTrigger.addEventListener("click", ()=>{
            const isClosed = group.classList.contains("h-0");
            closeAllOptionGroups();
            if (isClosed) {
                group.classList.remove("h-0");
                group.classList.add("flex", "flex-col", "h-auto");
                displayArrow?.classList.add("hidden");
                displayTrigger.classList.add("hover:border-b");
            }
        });
        buttons.forEach((btn)=>{
            btn.addEventListener("click", ()=>{
                const value = btn.dataset.pickupValue || "";
                const label = btn.dataset.pickupLabel || value;
                setActive(value, label);
            // closeAllOptionGroups();
            });
        });
    });
};
$c1a961f7c5111ced$export$350d9cc3c8c2e2a9();
// initProductAboSelectors(); // Abo disabled for now
$c1a961f7c5111ced$export$d860d8ed399a1993();


const $2b026a0002d891dd$var$CUSTOMER_COOKIE = "sauer_customer";
const $2b026a0002d891dd$var$CUSTOMER_FIELDS = [
    "first_name",
    "last_name",
    "email",
    "phone"
];
const $2b026a0002d891dd$var$COOKIE_MAX_AGE = 15552000; // 180 days
function $2b026a0002d891dd$var$saveCustomerCookie(form) {
    const data = {};
    for (const name of $2b026a0002d891dd$var$CUSTOMER_FIELDS)data[name] = form.elements[name]?.value ?? "";
    const encoded = encodeURIComponent(JSON.stringify(data));
    document.cookie = `${$2b026a0002d891dd$var$CUSTOMER_COOKIE}=${encoded}; max-age=${$2b026a0002d891dd$var$COOKIE_MAX_AGE}; path=/; SameSite=Lax`;
}
function $2b026a0002d891dd$var$loadCustomerCookie() {
    const match = document.cookie.split("; ").find((row)=>row.startsWith($2b026a0002d891dd$var$CUSTOMER_COOKIE + "="));
    if (!match) return null;
    try {
        return JSON.parse(decodeURIComponent(match.split("=").slice(1).join("=")));
    } catch  {
        return null;
    }
}
function $2b026a0002d891dd$var$prefillCheckoutForm(container) {
    const saved = $2b026a0002d891dd$var$loadCustomerCookie();
    if (!saved) return;
    const form = container.querySelector("[data-checkout-form]");
    if (!form) return;
    // Delay to let browser autofill run first
    setTimeout(()=>{
        for (const name of $2b026a0002d891dd$var$CUSTOMER_FIELDS){
            const input = form.elements[name];
            if (input && input.value === "" && saved[name]) {
                input.value = saved[name];
                input.dispatchEvent(new Event("input", {
                    bubbles: true
                }));
            }
        }
    }, 120);
}
const $2b026a0002d891dd$var$overlay = document.querySelector("[data-product-overlay]");
const $2b026a0002d891dd$var$panel = document.querySelector("[data-product-panel]");
const $2b026a0002d891dd$var$panelBody = document.querySelector("[data-product-panel-body]");
const $2b026a0002d891dd$var$closeButton = document.querySelector("[data-product-close]");
const $2b026a0002d891dd$var$cartPanel = document.querySelector("[data-cart-panel]");
const $2b026a0002d891dd$var$cartPanelBody = document.querySelector("[data-cart-panel-body]");
const $2b026a0002d891dd$var$cartCloseButton = document.querySelector("[data-cart-close]");
const $2b026a0002d891dd$var$successPanel = document.querySelector("[data-success-panel]");
const $2b026a0002d891dd$var$successPanelBody = document.querySelector("[data-success-panel-body]");
const $2b026a0002d891dd$var$successCloseButton = document.querySelector("[data-success-close]");
const $2b026a0002d891dd$var$failedPanel = document.querySelector("[data-failed-panel]");
const $2b026a0002d891dd$var$failedPanelBody = document.querySelector("[data-failed-panel-body]");
const $2b026a0002d891dd$var$failedCloseButton = document.querySelector("[data-failed-close]");
const $2b026a0002d891dd$var$detailContainer = document.querySelector("[data-product-details]");
const $2b026a0002d891dd$var$openButtons = Array.from(document.querySelectorAll("[data-product-open]"));
const $2b026a0002d891dd$var$cartOpenButtons = Array.from(document.querySelectorAll("[data-cart-open]"));
const $2b026a0002d891dd$var$imageOpenButtons = Array.from(document.querySelectorAll("[data-product-image-open]"));
const $2b026a0002d891dd$var$cartCountElements = Array.from(document.querySelectorAll("[data-cart-count]"));
const $2b026a0002d891dd$var$updateCartCount = ()=>{
    // Sum up quantities from cart panel inputs
    const qtyInputs = $2b026a0002d891dd$var$cartPanelBody?.querySelectorAll('input[name^="items["]') ?? [];
    let count = 0;
    qtyInputs.forEach((input)=>{
        count += parseInt(input.value, 10) || 0;
    });
    $2b026a0002d891dd$var$cartCountElements.forEach((el)=>{
        el.textContent = count;
        el.classList.toggle("hidden", count === 0);
    });
};
if ($2b026a0002d891dd$var$overlay && $2b026a0002d891dd$var$panel && $2b026a0002d891dd$var$panelBody && $2b026a0002d891dd$var$detailContainer) {
    // Strip virtual segments so base works for /home, /cart, /checkout/success (e.g. /sauer-bar-test/home -> /sauer-bar-test/)
    const basePath = window.location.pathname.replace(/\/(cart|checkout\/success|checkout\/failed|home)\/?$/, "/");
    const baseUrl = window.location.origin + (basePath.endsWith("/") ? basePath : basePath + "/");
    const homeUrl = baseUrl;
    const cartUrl = `${baseUrl}cart`;
    const successUrl = `${baseUrl}checkout/success`;
    const cartPanelUrl = `${baseUrl}cart/panel`;
    const successPanelUrl = `${baseUrl}checkout/success/panel`;
    let activePanel = null;
    const setOverlayState = (isOpen)=>{
        $2b026a0002d891dd$var$overlay.classList.toggle("opacity-0", !isOpen);
        $2b026a0002d891dd$var$overlay.classList.toggle("pointer-events-none", !isOpen);
        $2b026a0002d891dd$var$overlay.setAttribute("aria-hidden", String(!isOpen));
        document.body.style.overflow = isOpen ? "hidden" : "";
    };
    const setPanelState = (target, isOpen)=>{
        if (!target) return;
        target.classList.toggle("translate-x-full", !isOpen);
        target.setAttribute("aria-hidden", String(!isOpen));
    };
    const renderProduct = (slug)=>{
        const detail = $2b026a0002d891dd$var$detailContainer.querySelector(`[data-product-content="${slug}"]`);
        if (!detail) return false;
        $2b026a0002d891dd$var$panelBody.innerHTML = detail.innerHTML;
        $2b026a0002d891dd$var$panelBody.querySelectorAll("[data-product-gallery]").forEach((gallery)=>{
            gallery.removeAttribute("data-gallery-bound");
            gallery.dataset.galleryIndex = "0";
        });
        $2b026a0002d891dd$var$panelBody.querySelectorAll("[data-qty-options]").forEach((group)=>{
            group.removeAttribute("data-qty-bound");
        });
        $2b026a0002d891dd$var$panelBody.querySelectorAll("[data-pickup-options]").forEach((group)=>{
            group.removeAttribute("data-pickup-bound");
        });
        (0, $6be3643148e663ef$export$69c3c142561da2b0)($2b026a0002d891dd$var$panelBody);
        (0, $c1a961f7c5111ced$export$350d9cc3c8c2e2a9)($2b026a0002d891dd$var$panelBody);
        (0, $c1a961f7c5111ced$export$d860d8ed399a1993)($2b026a0002d891dd$var$panelBody);
        return true;
    };
    const openProduct = (slug, url, push = true)=>{
        if (!renderProduct(slug)) return;
        $2b026a0002d891dd$var$imageOpenButtons.forEach((btn)=>btn.classList.remove("opacity-0"));
        // Deactivate keeping the text visible when product aside comes in
        // const activeImage = imageOpenButtons.find(
        //   (btn) => btn.getAttribute("data-product-slug") === slug
        // );
        // activeImage?.classList.add("opacity-0");
        setPanelState($2b026a0002d891dd$var$cartPanel, false);
        setPanelState($2b026a0002d891dd$var$successPanel, false);
        setPanelState($2b026a0002d891dd$var$failedPanel, false);
        setPanelState($2b026a0002d891dd$var$panel, true);
        setOverlayState(true);
        activePanel = "product";
        if (push) history.pushState({
            product: slug
        }, "", url || homeUrl);
        else history.replaceState({
            product: slug
        }, "", url || homeUrl);
    };
    const closeAllPanels = (push = true)=>{
        setPanelState($2b026a0002d891dd$var$panel, false);
        setPanelState($2b026a0002d891dd$var$cartPanel, false);
        setPanelState($2b026a0002d891dd$var$successPanel, false);
        setPanelState($2b026a0002d891dd$var$failedPanel, false);
        setOverlayState(false);
        activePanel = null;
        $2b026a0002d891dd$var$imageOpenButtons.forEach((btn)=>btn.classList.remove("opacity-0"));
        if (push) history.pushState({
            product: null
        }, "", homeUrl);
        else history.replaceState({
            product: null
        }, "", homeUrl);
        $2b026a0002d891dd$var$updateCartCount();
    };
    const renderCartPanel = async ()=>{
        if (!$2b026a0002d891dd$var$cartPanelBody) return;
        const response = await fetch(cartPanelUrl, {
            credentials: "same-origin"
        });
        if (response.ok) {
            $2b026a0002d891dd$var$cartPanelBody.innerHTML = await response.text();
            $2b026a0002d891dd$var$updateCartCount();
            $2b026a0002d891dd$var$prefillCheckoutForm($2b026a0002d891dd$var$cartPanelBody);
        }
    };
    const renderSuccessPanel = async ()=>{
        if (!$2b026a0002d891dd$var$successPanelBody) return;
        if ($2b026a0002d891dd$var$successPanelBody.innerHTML.trim() !== "") return;
        const response = await fetch(successPanelUrl, {
            credentials: "same-origin"
        });
        if (response.ok) $2b026a0002d891dd$var$successPanelBody.innerHTML = await response.text();
    };
    const openCart = async (push = true)=>{
        await renderCartPanel();
        setPanelState($2b026a0002d891dd$var$panel, false);
        setPanelState($2b026a0002d891dd$var$successPanel, false);
        setPanelState($2b026a0002d891dd$var$failedPanel, false);
        setPanelState($2b026a0002d891dd$var$cartPanel, true);
        setOverlayState(true);
        activePanel = "cart";
        if (push) history.pushState({
            cart: true
        }, "", cartUrl);
        else history.replaceState({
            cart: true
        }, "", cartUrl);
    };
    const openSuccess = async (push = true)=>{
        await renderSuccessPanel();
        setPanelState($2b026a0002d891dd$var$panel, false);
        setPanelState($2b026a0002d891dd$var$cartPanel, false);
        setPanelState($2b026a0002d891dd$var$successPanel, true);
        setPanelState($2b026a0002d891dd$var$failedPanel, false);
        setOverlayState(true);
        activePanel = "success";
        if (push) history.pushState({
            success: true
        }, "", successUrl);
        else history.replaceState({
            success: true
        }, "", successUrl);
    };
    const openFailed = (push = true)=>{
        setPanelState($2b026a0002d891dd$var$panel, false);
        setPanelState($2b026a0002d891dd$var$cartPanel, false);
        setPanelState($2b026a0002d891dd$var$successPanel, false);
        setPanelState($2b026a0002d891dd$var$failedPanel, true);
        setOverlayState(true);
        activePanel = "failed";
        if (push) history.pushState({
            failed: true
        }, "", homeUrl);
        else history.replaceState({
            failed: true
        }, "", homeUrl);
    };
    // Track if last interaction was touch
    let lastTouchTime = 0;
    document.addEventListener("touchstart", ()=>{
        lastTouchTime = Date.now();
    }, {
        passive: true
    });
    const wasRecentTouch = ()=>Date.now() - lastTouchTime < 500;
    $2b026a0002d891dd$var$openButtons.forEach((btn)=>{
        btn.addEventListener("click", (event)=>{
            event.preventDefault();
            const isImageLink = btn.hasAttribute("data-product-image-open");
            const isTouch = wasRecentTouch();
            // On touch, image links should do nothing (just show text behind)
            if (isTouch && isImageLink) return;
            const slug = btn.getAttribute("data-product-slug");
            if (!slug) return;
            openProduct(slug, btn.getAttribute("href"));
        });
    });
    $2b026a0002d891dd$var$cartOpenButtons.forEach((btn)=>{
        btn.addEventListener("click", (event)=>{
            event.preventDefault();
            openCart();
        });
    });
    $2b026a0002d891dd$var$overlay.addEventListener("click", ()=>closeAllPanels());
    $2b026a0002d891dd$var$closeButton?.addEventListener("click", ()=>closeAllPanels());
    $2b026a0002d891dd$var$cartCloseButton?.addEventListener("click", ()=>closeAllPanels());
    $2b026a0002d891dd$var$successCloseButton?.addEventListener("click", ()=>closeAllPanels());
    $2b026a0002d891dd$var$failedCloseButton?.addEventListener("click", ()=>closeAllPanels());
    $2b026a0002d891dd$var$panelBody.addEventListener("submit", async (event)=>{
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.querySelector("[data-open-cart]")) return;
        event.preventDefault();
        const response = await fetch(form.action, {
            method: form.method || "POST",
            body: new FormData(form),
            credentials: "same-origin"
        });
        if (!response.ok) return;
        await openCart();
    });
    $2b026a0002d891dd$var$cartPanelBody?.addEventListener("submit", async (event)=>{
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (form.matches("[data-checkout-form]")) {
            if (!form.checkValidity()) {
                event.preventDefault();
                form.dataset.submitted = "true";
                return;
            }
            event.preventDefault();
            $2b026a0002d891dd$var$saveCustomerCookie(form);
            // Disable submit button to prevent double-clicks
            const submitBtn = form.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn?.textContent;
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = "Weiterleitung...";
            }
            try {
                const response = await fetch(form.action, {
                    method: form.method || "POST",
                    body: new FormData(form),
                    credentials: "same-origin",
                    headers: {
                        Accept: "application/json"
                    }
                });
                const data = await response.json();
                if (data.redirect) {
                    // Redirect to Payrexx checkout (external URL) or success page
                    window.location.href = data.redirect;
                    return;
                }
                if (!response.ok) {
                    console.error("Checkout error:", data.error);
                    if (submitBtn) {
                        submitBtn.disabled = false;
                        submitBtn.textContent = originalBtnText;
                    }
                    return;
                }
                // Fallback: if no redirect, show success panel
                $2b026a0002d891dd$var$cartPanelBody.innerHTML = "";
                await openSuccess();
            } catch (err) {
                console.error("Checkout fetch error:", err);
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalBtnText;
                }
            }
            return;
        }
        event.preventDefault();
        const response = await fetch(form.action, {
            method: form.method || "POST",
            body: new FormData(form),
            credentials: "same-origin"
        });
        if (!response.ok) return;
        await renderCartPanel();
    });
    $2b026a0002d891dd$var$cartPanelBody?.addEventListener("click", (event)=>{
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;
        const link = target.closest("[data-product-open]");
        if (!(link instanceof HTMLAnchorElement)) return;
        event.preventDefault();
        const slug = link.getAttribute("data-product-slug");
        if (!slug) return;
        openProduct(slug, link.getAttribute("href"));
    });
    $2b026a0002d891dd$var$cartPanelBody?.addEventListener("change", async (event)=>{
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (target.name && target.name.startsWith("items[")) {
            if (target.value === "") return;
            const form = target.closest("form");
            if (!form) return;
            const response = await fetch(form.action, {
                method: form.method || "POST",
                body: new FormData(form),
                credentials: "same-origin"
            });
            if (!response.ok) return;
            await renderCartPanel();
        }
    });
    const qtyInputTimers = new WeakMap();
    $2b026a0002d891dd$var$cartPanelBody?.addEventListener("input", (event)=>{
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (!target.name || !target.name.startsWith("items[")) return;
        if (target.value === "") return;
        const form = target.closest("form");
        if (!form) return;
        const prevTimer = qtyInputTimers.get(target);
        if (prevTimer) clearTimeout(prevTimer);
        const timer = setTimeout(async ()=>{
            const response = await fetch(form.action, {
                method: form.method || "POST",
                body: new FormData(form),
                credentials: "same-origin"
            });
            if (!response.ok) return;
            if (document.activeElement !== target) await renderCartPanel();
        }, 300);
        qtyInputTimers.set(target, timer);
    });
    window.addEventListener("popstate", (event)=>{
        const slug = event.state?.product;
        const cart = event.state?.cart;
        const success = event.state?.success;
        const failed = event.state?.failed;
        if (slug) {
            openProduct(slug, null, false);
            return;
        }
        if (cart) {
            openCart(false);
            return;
        }
        if (success) {
            openSuccess(false);
            return;
        }
        if (failed) {
            openFailed(false);
            return;
        }
        closeAllPanels(false);
    });
    const params = new URLSearchParams(window.location.search);
    const initialSlug = params.get("product");
    if (initialSlug) openProduct(initialSlug, window.location.href, false);
    if (/\/cart\/?$/.test(window.location.pathname)) openCart(false);
    // Return from Payrexx: same page as Warenkorb, open existing success aside
    if (new URLSearchParams(window.location.search).get("success") === "1") openSuccess(false);
    // Return from failed payment: open failed aside
    if (new URLSearchParams(window.location.search).get("failed") === "1") openFailed(false);
}




(0, (/*@__PURE__*/$parcel$interopDefault($5fdb0a20b06ec8d0$exports))).polyfill();

})();
//# sourceMappingURL=main.js.map
